import { fetchToken, fetchTokenFile } from "../helpers/fetch";
import { const_routes } from "../helpers/const_routes";

const handleAuth = (body, dispatch) => {
  if (body?.code === "bak-aut-tok-exp-001" || body?.code === "bak-aut-tok-inv-001") {
    dispatch({ type: "[Auth] Logout" });
  }
};

export const startDownloadCurrentModuleConfigExcel = () => async (dispatch) => {
  const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_MODULE_CONFIG, "export-excel");
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    handleAuth(body, dispatch);
    return { ok: false, msg: body.msg || "download-error" };
  }
  const blob = await resp.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "moduleconfig_current.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true };
};

export const startDownloadModuleConfigExcelErrors = (bagRowProcess) => async (dispatch) => {
  const resp = await fetchToken(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_MODULE_CONFIG,
    "download-errors",
    { bagRowProcess },
    "POST"
  );
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    handleAuth(body, dispatch);
    return { ok: false, msg: body.msg };
  }
  const blob = await resp.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "moduleconfig_import_errors.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true };
};

export const startImportModuleConfigExcel = (file, apply) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("apply", apply ? "true" : "false");
  const resp = await fetchTokenFile(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_MODULE_CONFIG,
    "import-excel",
    formData,
    "POST"
  );
  const body = await resp.json();
  handleAuth(body, dispatch);
  return body;
};
